import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { Deps, State } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { from } from 'rxjs'
import { paymentActions, PaymentActions } from './payment.actions'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

interface Action$ extends ActionsObservable<PaymentActions> {}
interface State$ extends StateObservable<State> {}

const doPayment = (dsService: DSService) => (p: { [startFetch]: string }) =>
  from(
    dsService.getCompanies().map(companiesOpt =>
      pipe(
        companiesOpt,
        O.fold(
          () => paymentActions.PaymentFailed({ [stopFetch]: p[startFetch] }),
          _ => paymentActions.PaymentSuccess({ [stopFetch]: p[startFetch] })
        )
      )
    )
  )

export const doPaymentEpic = (action$: Action$, _: State$, deps: Deps) =>
  action$.pipe(
    filter(paymentActions.is.DoPayment),
    mergeMap(doPayment(deps.dsService))
  )

export const paymentEpics = combineEpics(doPaymentEpic)



// WEBPACK FOOTER //
// ./src/payment/payment.epics.ts